import styled from "styled-components";
import { motion } from "framer-motion";
export const Section = styled(motion.div)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 2rem;
  flex-wrap: wrap;
  .image-div {
    flex: 1;
    flex-basis: 28rem;
    margin-left: 2rem;
    margin-right: -4rem;
    img {
      width: 75%;
      height: 70%;
    }
  }
`;
export const Description = styled.div`
  flex: 1;
  flex-basis: 32rem;
  /* padding: 0rem 2rem 2rem 2rem; */
  margin-top: -2rem;
  padding-left: 2rem;
  @media screen and (max-width: 768px) {
    margin-top: 0;
  }
`;
export const Title = styled.div`
  width: 100%;
  .line-1,
  .line-2 {
    /* font-size: 200%; */
    span {
      color: #8b73ff;
    }
  }
`;
